import { z } from 'zod';

// ============================================================================
// LENIENT SCHEMA (for deserialization)
// ============================================================================
const lenientVaultSettingsNodeSchema = z.object({
  enablePets: z.boolean().optional().catch(undefined),
  enableVehicles: z.boolean().optional().catch(undefined),
  enableProperties: z.boolean().optional().catch(undefined),
  enableItems: z.boolean().optional().catch(undefined),
  enableSavings: z.boolean().optional().catch(undefined),
  enableProtection: z.boolean().optional().catch(undefined),
  enableLiabilities: z.boolean().optional().catch(undefined),
}).transform(val => ({
  enablePets: val.enablePets ?? true,
  enableVehicles: val.enableVehicles ?? true,
  enableProperties: val.enableProperties ?? true,
  enableItems: val.enableItems ?? true,
  enableSavings: val.enableSavings ?? true,
  enableProtection: val.enableProtection ?? true,
  enableLiabilities: val.enableLiabilities ?? true,
}));

// ============================================================================
// STRICT SCHEMA (for validation)
// ============================================================================
const strictVaultSettingsNodeSchema = z.object({
  enablePets: z.boolean().default(true),
  enableVehicles: z.boolean().default(true),
  enableProperties: z.boolean().default(true),
  enableItems: z.boolean().default(true),
  enableSavings: z.boolean().default(true),
  enableProtection: z.boolean().default(true),
  enableLiabilities: z.boolean().default(true),
}).transform(val => ({
  enablePets: val.enablePets ?? true,
  enableVehicles: val.enableVehicles ?? true,
  enableProperties: val.enableProperties ?? true,
  enableItems: val.enableItems ?? true,
  enableSavings: val.enableSavings ?? true,
  enableProtection: val.enableProtection ?? true,
  enableLiabilities: val.enableLiabilities ?? true,
}));

// ============================================================================
// TYPE
// ============================================================================
export type VaultSettingsNode = z.infer<typeof lenientVaultSettingsNodeSchema>;

// ============================================================================
// NAMESPACE (for Methods)
// ============================================================================
export namespace VaultSettingsNode {
  export function deserialize(data: unknown): VaultSettingsNode {
    return lenientVaultSettingsNodeSchema.parse(data ?? {});
  }

  export function create(data: unknown): VaultSettingsNode {
    return strictVaultSettingsNodeSchema.parse(data ?? {});
  }

  export function createDefault(): VaultSettingsNode {
    return {
      enablePets: true,
      enableVehicles: true,
      enableProperties: true,
      enableItems: true,
      enableSavings: true,
      enableProtection: true,
      enableLiabilities: true,
    };
  }
}
